import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "极农订单处理工作台", -1)
const _hoisted_3 = { class: "edit-btn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("原始单据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("商品汇总单")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("自提点商品汇总单")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("自提点订单")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("订单小票")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("自提点综合单")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("自提点汇总")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("小票显示配置")
const _hoisted_14 = { class: "canvas-box" }
const _hoisted_15 = { id: "default-excel" }
const _hoisted_16 = { id: "all-round" }
const _hoisted_17 = { class: "loading" }
const _hoisted_18 = { class: "operation-container" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("订单状态")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("跟团号&下单人")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提货点")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("联系人")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("收货地址")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("下单时间")
const _hoisted_25 = { class: "btn-container" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("关闭")

import { read, utils } from 'xlsx';
import { ref, onMounted, getCurrentInstance, nextTick } from "vue"
import locationSummary from "./components/locationSummary.vue";
import productSummary from "./components/productSummary.vue";
import locationOrder from "./components/locationOrder.vue";
import orderReceipt from "./components/orderReceipt.vue";
import pointSummary from "./components/pointSummary.vue";
import canvasDatagrid from "canvas-datagrid";
import { Notify } from 'vant';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = ref<any>([])
const tab = ref(-1)
const file = ref({})
const grid = ref<any>({})
const count = ref<any>({})
const show = ref(false)
const setPop = ref(false)
const setObj = ref({
	orderStatus: true,
	leader: true,
	location: true,
	consignee: true,
	address: true,
	paymentTime: true,
})
const print = () => {
	window.print()
}
const onhandlePop = (e: boolean) => {
	setPop.value = e
}
const onChange = (value: any, checkbox: any) => {
	switch (checkbox) {
		case 1:
			setObj.value.orderStatus = value
			break;
		case 2:
			setObj.value.leader = value
			break;
		case 3:
			setObj.value.location = value
			break;
		case 4:
			setObj.value.consignee = value
			break;
		case 5:
			setObj.value.address = value
			break;
		case 6:
			setObj.value.paymentTime = value
			break;
	}
}
const handleChangeTab = (e: number) => {
	if (!data.value.length) {
		Notify({ type: "danger", message: "请上传文件" });
	} else {
		tab.value = e
		nextTick(() => {
			processingData(data.value);

		})
	}
}
const cancel = () => {
	show.value = false
}
const handleChange = (e: any) => {
	show.value = true
	tab.value = 0
	file.value = e.target.files[0]
	const reader = new FileReader();
	reader.onload = (loadEvent: any) => {
		const el = document.querySelector("#default-excel")
		const arrayBuffer = loadEvent.target.result;
		const wb = read(arrayBuffer);
		const ws = wb.Sheets[wb.SheetNames[0]]
		data.value = utils.sheet_to_json(ws);
		if (Object.prototype.toString.call(grid.value) != '[object HTMLElement]') {
			grid.value = canvasDatagrid({
				parentNode: el, // el 是 document 中的一个 DOM 元素
				data: data.value, // json 是前面解析得到 sheet 对应的数据
				editable: true, // 表示不使用表格编辑
			});
			cancel()
			grid.value.style.width = "100%"; // 宽度为视口宽度
			grid.value.style.height = "calc(100vh - 73px)"; // 视口高度减去顶部的 sheet 切换按钮区高度
		} else {
			grid.value.data = data.value
			cancel()
		}
	};
	// 读取文件
	reader.readAsArrayBuffer(e.target.files[0]);
}
const processingData = (data: any) => {
	show.value = true
	let excelData: any = []
	const el = document.querySelector("#all-round")
	const locationArr = categorizeOrdersByPickupPoint(data, '自提点')
	let leftHead: any = Object.keys(categorizeOrdersByPickupPoint(data, '自提点'))
	let thead: any = Object.keys(categorizeOrdersByPickupPoint(data, '商品'))
	thead = ['自提点', '团长', ...thead, '总计', '自提点联系人', '自提点地址']
	excelData = [thead]
	leftHead = ['自提点', ...leftHead, '总计']
	leftHead.forEach((item: any, index: number) => {
		if (index) {
			let arr: any = []
			thead.forEach(() => arr.push(""))
			excelData.push([item, ...arr])
		}
	})
	let lastCount = 0
	leftHead.forEach((item: any, index: number) => {
		let colCount = 0
		if (index && index != leftHead.length - 1) {
			locationArr[item].forEach((value: any, inx: number) => {
				thead.forEach((val: any, idx: number) => {
					if (value['商品'] == val) {
						excelData[index][idx] = Number(excelData[index][idx]) + Number(value['数量'])
						colCount += Number(value['数量'])
						excelData[leftHead.length - 1][idx] = Number(excelData[leftHead.length - 1][idx]) + Number(value['数量'])
						lastCount += colCount
					}
					if (idx == 1) excelData[index][idx] = value['团长']
					if (val == '总计') {
						excelData[index][idx] = colCount
						excelData[leftHead.length - 1][idx] = Number(excelData[leftHead.length - 1][idx]) + Number(value['数量'])
						if (item == '总计') excelData[index][idx] = lastCount
					}
					if (val == '自提点联系人') excelData[index][idx] = value['自提点联系人'] ? value['自提点联系人'] + '(' + value['自提点电话'] + ')' : ''
					if (val == '自提点地址') excelData[index][idx] = value['自提点地址']
				})
			})
		}
	})
	if (Object.prototype.toString.call(count.value) != '[object HTMLElement]') {
		count.value = canvasDatagrid({
			parentNode: el, // el 是 document 中的一个 DOM 元素
			data: excelData, // json 是前面解析得到 sheet 对应的数据
			editable: true, // 表示不使用表格编辑
		});
		cancel()
		count.value.style.width = "100%"; // 宽度为视口宽度
		count.value.style.height = "calc(100vh - 73px)"; // 视口高度减去顶部的 sheet 切换按钮区高度
	} else {
		count.value.data = excelData
		cancel()
	}
}
const categorizeOrdersByPickupPoint = (ordersArray: any, name: string) => {
	const categorizedOrders: any = {};
	for (const order of ordersArray) {
		const pickupPoint = order[name];
		if (!categorizedOrders[pickupPoint]) {
			categorizedOrders[pickupPoint] = [];
		}
		categorizedOrders[pickupPoint].push(order);
	}
	return categorizedOrders;
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_uploader, {
        onChange: handleChange,
        accept: ".xls,.xlsx,.xlsm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_button, {
            icon: "plus",
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeTab(0))),
        plain: "",
        size: "small",
        type: tab.value == 0 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeTab(1))),
        plain: "",
        size: "small",
        type: tab.value == 1 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleChangeTab(2))),
        plain: "",
        size: "small",
        type: tab.value == 2 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChangeTab(3))),
        plain: "",
        size: "small",
        type: tab.value == 3 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleChangeTab(4))),
        plain: "",
        size: "small",
        type: tab.value == 4 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleChangeTab(5))),
        plain: "",
        size: "small",
        type: tab.value == 5 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_van_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (handleChangeTab(6))),
        plain: "",
        size: "small",
        type: tab.value == 6 ? 'warning' : 'primary'
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["type"]),
      (tab.value != 0 && tab.value != -1 && tab.value != 5)
        ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (print())),
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (tab.value == 4)
        ? (_openBlock(), _createBlock(_component_van_button, {
            key: 1,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (onhandlePop(true))),
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
        [_vShow, tab.value == 0]
      ]),
      (tab.value == 1)
        ? (_openBlock(), _createBlock(productSummary, {
            key: 0,
            initData: data.value
          }, null, 8, ["initData"]))
        : _createCommentVNode("", true),
      (tab.value == 2)
        ? (_openBlock(), _createBlock(locationSummary, {
            key: 1,
            initData: data.value
          }, null, 8, ["initData"]))
        : _createCommentVNode("", true),
      (tab.value == 3)
        ? (_openBlock(), _createBlock(locationOrder, {
            key: 2,
            initData: data.value
          }, null, 8, ["initData"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
        [_vShow, tab.value == 5]
      ]),
      (tab.value == 4)
        ? (_openBlock(), _createBlock(orderReceipt, {
            key: 3,
            file: file.value,
            initData: data.value,
            setData: setObj.value
          }, null, 8, ["file", "initData", "setData"]))
        : _createCommentVNode("", true),
      (tab.value == 6)
        ? (_openBlock(), _createBlock(pointSummary, {
            key: 4,
            initData: data.value
          }, null, 8, ["initData"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_overlay, { show: show.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_van_loading, {
            color: "#1989fa",
            size: "50px"
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: setPop.value,
      onClose: _cache[22] || (_cache[22] = ($event: any) => (onhandlePop(false)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "orderStatus",
            modelValue: setObj.value.orderStatus,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (setObj.value.orderStatus = $event)),
            onChange: _cache[10] || (_cache[10] = ($event: any) => (onChange(setObj.value.orderStatus, 1)))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "leader",
            modelValue: setObj.value.leader,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (setObj.value.leader = $event)),
            onChange: _cache[12] || (_cache[12] = ($event: any) => (onChange(setObj.value.leader, 2)))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "location",
            modelValue: setObj.value.location,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (setObj.value.location = $event)),
            onChange: _cache[14] || (_cache[14] = ($event: any) => (onChange(setObj.value.location, 3)))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "consignee",
            modelValue: setObj.value.consignee,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (setObj.value.consignee = $event)),
            onChange: _cache[16] || (_cache[16] = ($event: any) => (onChange(setObj.value.consignee, 4)))
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "address",
            modelValue: setObj.value.address,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (setObj.value.address = $event)),
            onChange: _cache[18] || (_cache[18] = ($event: any) => (onChange(setObj.value.address, 5)))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_checkbox, {
            class: "checked",
            name: "paymentTime",
            modelValue: setObj.value.paymentTime,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (setObj.value.paymentTime = $event)),
            onChange: _cache[20] || (_cache[20] = ($event: any) => (onChange(setObj.value.paymentTime, 6)))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_van_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (onhandlePop(false))),
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})